const PARSER_JOBSCAN_LEGACY = 'jobscan-legacy';
const PARSER_JOBSCAN = 'jobscan';
const PARSER_OPENAI = 'openai';
const PARSER_OPENROUTER = 'openrouter';

interface ParserInfo {
    isForked: boolean;
    parser: string;
    version: string;
}

const parserTextMap: Record<string, (info: ParserInfo) => string> = {
    [PARSER_JOBSCAN_LEGACY]: () => 'Blackbox Parser',
    [PARSER_JOBSCAN]: info => `Jobscan Parser (version ${info.version})`,
    [PARSER_OPENAI]: () => 'OpenAI Parser',
    [PARSER_OPENROUTER]: info => `OpenRouter (${info.version})`,
};

export function getParserText(parserInfo?: ParserInfo): string | null {
    if (!parserInfo?.parser) return null;

    const fn = parserTextMap[parserInfo.parser];

    if (!fn) return null;

    if (parserInfo.isForked) {
        return `Forked (${fn(parserInfo)})`;
    }
    return fn(parserInfo);
}
